<div id="admin-bar">
  <div class="admin-bar-title">Admin. Services</div>
  <div class="services-wrapper">
    <!-- <a *ngFor="let service of internalServices" class="menu-item" (click)="onMenuItem(service)"
        [routerLink]="[service.path]"> -->
    <!--     <a
      *ngFor="let service of internalServices"
      class="menu-item"
      [ngClass]="{ selected: service.path === currentServicePath }"
      [routerLink]="[service.path]">
      <img [src]="service.icon" [alt]="service.name + ' icon'" />
      <span class="menu-item-text d-none d-xl-block">{{ service.privatename }}</span>
    </a> -->
    <div *ngFor="let tab of internalServicesPerTab" class="service-tab" (click)="toggleTab(tab.key)"
      [ngClass]="{ active: !tab.hidden }">
      <div>{{ tab.name }} <img src="/assets/img/icons/arrow-down-bold-white.svg" alt="arrow-down-white" /></div>
      <div class="submenu" [hidden]="tab.hidden">
        <a *ngFor="let menuitem of tab.services" class="submenu-item" [routerLink]="[menuitem.path]">
          <div>
            <img [src]="menuitem.icon" [alt]="menuitem.name + ' icon'" />
            <span>{{ menuitem.privatename }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>